<template>
  <div class="container lnb d_container change_tab">
    <div class="contents_wrap">
      <div class="contents list-container">
        <div class="title">
          {{ termsType() }} 약관/규정
<!--          <el-button class="title_btn" @click="moveCreate()" type="primary">등록</el-button>-->
        </div>
        <div class="terms-content mb20">
          <div class="terms_tab_wrap">
            <div class="terms_category">약관</div>
            <div class="terms_tab" @click="changeTab('service')" :class="{active: tab == 'service'}">서비스이용약관</div>
            <div class="terms_tab" @click="changeTab('privacy')" :class="{active: tab == 'privacy'}">개인정보처리방침</div>
            <div class="terms_tab" @click="changeTab('leave')" :class="{active: tab == 'leave'}">회원탈퇴약관</div>
          </div>
          <div class="terms_tab_wrap">
            <div class="terms_category">아이템</div>
            <div class="terms_tab" @click="changeTab('product')" :class="{active: tab == 'product'}">아이템 등록 규정</div>
              <div class="terms_tab" @click="changeTab('itembuy')" :class="{active: tab == 'itembuy'}">아이템 구매 규정</div>
            <div class="terms_tab" @click="changeTab('auctionSell')" :class="{active: tab == 'auctionSell'}">경매 판매 규정</div>
            <div class="terms_tab" @click="changeTab('auctionBuy')" :class="{active: tab == 'auctionBuy'}">입찰 및 낙찰 규정</div>
            <div class="terms_tab" @click="changeTab('productSell')" :class="{active: tab == 'productSell'}">지정가 판매 규정</div>
            <div class="terms_tab" @click="changeTab('licenseSell')" :class="{active: tab == 'licenseSell'}">라이선스 판매 규정</div>
            <div class="terms_tab" @click="changeTab('licenseBuy')" :class="{active: tab == 'licenseBuy'}">라이선스 구매 규정</div>
          </div>
          <div class="terms_tab_wrap">
            <div class="terms_category">공모전</div>
            <div class="terms_tab" @click="changeTab('contest')" :class="{active: tab == 'contest'}">공모전 등록 규정</div>
            <div class="terms_tab" @click="changeTab('contestItem')" :class="{active: tab == 'contestItem'}">공모전 응모 규정</div>
            <div class="terms_tab" @click="changeTab('contestWin')" :class="{active: tab == 'contestWin'}">수상작 선정 규정</div>
            <div class="terms_tab" @click="changeTab('curator')" :class="{active: tab == 'curator'}">큐레이터</div>
            <div class="terms_tab" @click="changeTab('curatorForm')" :class="{active: tab == 'curatorForm'}">큐레이터 신청 규정</div>
            <div class="terms_tab" @click="changeTab('curation')" :class="{active: tab == 'curation'}">큐레이션 규정</div>
          </div>
          <div class="terms_tab_wrap">
            <div class="terms_category">검출</div>
            <div class="terms_tab" @click="changeTab('lawsuit')" :class="{active: tab == 'lawsuit'}">의뢰 안내문</div>
            <div class="terms_tab" @click="changeTab('lawsuitRequest')" :class="{active: tab == 'lawsuitRequest'}">의뢰 위임장</div>
            <div class="terms_tab" @click="changeTab('mingle')" :class="{active: tab == 'mingle'}">밍글</div>
            <div class="terms_tab" @click="changeTab('charge')" :class="{active: tab == 'charge'}">충전 안내</div>
            <div class="terms_tab" @click="changeTab('withdraw')" :class="{active: tab == 'withdraw'}">출금 안내</div>
            <div class="terms_tab" @click="changeTab('fees')" :class="{active: tab == 'fees'}">수수료 규정</div>
            <div class="terms_tab" @click="changeTab('detection')" :class="{active: tab == 'detection'}">검출 내역 안내문</div>
            <div class="terms_tab" @click="changeTab('point')" :class="{active: tab == 'point'}">포인트 사용 규정</div>
          </div>
        </div>
        <div v-if="tab === 'service'">
          <terms-list-component :termsType="`service`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'privacy'">
          <terms-list-component :termsType="`privacy`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'leave'">
          <terms-list-component :termsType="`leave`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'auctionSell'">
          <terms-list-component :termsType="`auctionSell`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'product'">
          <terms-list-component :termsType="`product`"></terms-list-component>
        </div>
          <div v-else-if="tab === 'itembuy'">
              <terms-list-component :termsType="`itembuy`"></terms-list-component>
          </div>
        <div v-else-if="tab === 'auctionBuy'">
          <terms-list-component :termsType="`auctionBuy`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'licenseSell'">
          <terms-list-component :termsType="`licenseSell`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'licenseBuy'">
          <terms-list-component :termsType="`licenseBuy`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'productSell'">
          <terms-list-component :termsType="`productSell`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'contest'">
          <terms-list-component :termsType="`contest`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'contestItem'">
          <terms-list-component :termsType="`contestItem`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'contestWin'">
          <terms-list-component :termsType="`contestWin`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'curator'">
          <terms-list-component :termsType="`curator`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'curatorForm'">
          <terms-list-component :termsType="`curatorForm`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'curation'">
          <terms-list-component :termsType="`curation`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'lawsuit'">
          <terms-list-component :termsType="`lawsuit`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'lawsuitRequest'">
          <terms-list-component :termsType="`lawsuitRequest`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'mingle'">
          <terms-list-component :termsType="`mingle`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'charge'">
          <terms-list-component :termsType="`charge`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'withdraw'">
          <terms-list-component :termsType="`withdraw`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'detection'">
          <terms-list-component :termsType="`detection`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'point'">
          <terms-list-component :termsType="`point`"></terms-list-component>
        </div>
        <div v-else-if="tab === 'fees'">
          <terms-list-component :termsType="`fees`"></terms-list-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TermsListComponent from "@/components/terms/TermsListComponent";
import util from "@/mixins/util";

export default {
  name: "Terms",
  mixins: [],
  components: {
    TermsListComponent
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      tab: 'service',
    }
  },
  beforeRouterEnter() {},
  created() {
    this.tab = this.$route.query.tab;
    if (util.isEmpty(this.tab)) {
      this.changeTab('service');
    }
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    changeTab(tab) {
      this.$router.replace(this.$route.path);
      this.tab = '';
      this.$nextTick(() => {
        this.tab = tab
      })
      this.$router.replace(`${this.$route.path}?tab=${tab}`);
    },
    moveCreate() {
      this.$router.replace(`${this.$route.path}?tab=${this.tab}`);
      this.$router.push(`/site/terms/create/${this.tab}`);
    },
    termsType() {
      if (this.tab === 'service') {
        return '서비스 이용약관'
      } else if (this.tab === 'privacy') {
        return '개인정보처리방침'
      } else if (this.tab === 'leave') {
        return '회원탈퇴약관'
      }else if(this.tab === 'auctionSell') {
        return '경매 판매 규정'
      }else if(this.tab === 'product') {
        return '아이템 등록 규정'
      } else if(this.tab === 'auctionBuy') {
        return '입찰 및 낙찰 규정'
      } else if(this.tab === 'licenseSell') {
        return '라이센스 판매 규정'
      } else if(this.tab === 'licenseBuy') {
        return '라이센스 구매 규정'
      } else if(this.tab === 'productSell') {
        return '지정가 판매'
      } else if(this.tab === 'contest') {
        return '공모전 등록 규정'
      } else if(this.tab === 'contestItem') {
        return '공모전 응모 규정'
      } else if(this.tab === 'contestWin') {
        return '수상작 선정 규정'
      } else if(this.tab === 'curator') {
        return '큐레이터'
      } else if(this.tab === 'curatorForm') {
        return '큐레이터 신청 규정'
      } else if(this.tab === 'curation') {
        return '큐레이션 신청 안내'
      } else if(this.tab === 'lawsuit') {
        return '의뢰안내문'
      } else if(this.tab === 'lawsuitRequest') {
        return '의뢰위임장'
      } else if(this.tab === 'mingle') {
        return '밍글'
      } else if(this.tab === 'charge') {
        return '충전 안내'
      } else if(this.tab === 'withdraw') {
        return '출금 안내'
      } else if(this.tab === 'detection') {
        return '검출 내역 안내문'
      } else if(this.tab === 'point') {
        return '포인트 사용 규정'
      } else if(this.tab === 'fees') {
        return '수수료 규정'
      }
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
